// assets/bundle-images.js
(function () {
  const mount = document.getElementById('bundle-image-options');
  if (!mount || mount.dataset._bi === '1') return; mount.dataset._bi = '1';

  const norm = (s) => String(s ?? '').replace(/\s+/g, ' ').trim().toLowerCase();

  // Product JSON
  const ps = document.querySelector('[id^="ProductJson-"]') ||
             document.querySelector('[id^="product-json-"]') ||
             document.querySelector('script[type="application/json"][data-product]');
  if (!ps) return;
  let product; try { product = JSON.parse(ps.textContent); } catch { return; }
  if (!product?.variants?.length) return;

  // Which option is bundle?
  const bundleIdx = (() => {
    const opts = product.options || [];
    let i = opts.findIndex(o => /bundle|bags/i.test(String(o)));
    if (i === -1) i = opts.findIndex(o => norm(o) === 'choose your bundle');
    return i === -1 ? 0 : i;
  })();
  const bundleLabel = product.options[bundleIdx] || 'Bundle';

  // Images
  const IMAGES = {
    '2 bags': {
      desktop: 'https://storage.googleapis.com/msgsndr/cdDGInpmtyqsXHhs6i0c/media/68fb96699b2f63661a266cb4.png',
      mobile:  'https://storage.googleapis.com/msgsndr/cdDGInpmtyqsXHhs6i0c/media/68fbb4805947eb035cbc0d06.png'
    },
    '3 bags': {
      desktop: 'https://storage.googleapis.com/msgsndr/cdDGInpmtyqsXHhs6i0c/media/68fb966954fb6261956f2fab.png',
      mobile:  'https://storage.googleapis.com/msgsndr/cdDGInpmtyqsXHhs6i0c/media/68fbb480f1ef983855ee5ba9.png'
    },
    '4 bags': {
      desktop: 'https://storage.googleapis.com/msgsndr/cdDGInpmtyqsXHhs6i0c/media/68fc6679370289914c429d79.png',
      mobile:  'https://storage.googleapis.com/msgsndr/cdDGInpmtyqsXHhs6i0c/media/68fc6679afcd2177dfc57e20.png'
    }
  };

  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const forms = () => $$('product-form form, form[action*="/cart/add"]');

  function findBundleGroup(form) {
    const groups = $$('.product-form__input, .product-form__input--pill, fieldset', form);
    return groups.find(g => {
      const t = norm((g.querySelector('legend, label')?.textContent) || '');
      return t.includes('bundle') || t.includes('bags') || t.includes(norm(bundleLabel));
    }) || null;
  }

  function currentBundleFromDOM() {
    for (const f of forms()) {
      const g = findBundleGroup(f);
      if (!g) continue;
      const r = g.querySelector('input[type="radio"]:checked');
      if (r) return r.value;
    }
    return null;
  }

  function clickNativeBundle(value) {
    const want = norm(value);
    forms().forEach(f => {
      const g = findBundleGroup(f);
      if (!g) return;
      const radios = $$('input[type="radio"]', g);
      const target = radios.find(r => norm(r.value) === want);
      if (target) {
        target.checked = true;
        target.click();
        target.dispatchEvent(new Event('input',  { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
        f.dispatchEvent(new Event('change',      { bubbles: true }));
      }
    });
  }

  // Build cards ONCE
  function buildOnce() {
    mount.innerHTML = '';
    const wrap = document.createElement('div');
    wrap.className = 'bundle-cards';
    mount.appendChild(wrap);

    Object.keys(IMAGES).forEach(val => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'bundle-card';
      card.dataset.value = val;
      const src = (matchMedia('(max-width:640px)').matches ? IMAGES[val].mobile : IMAGES[val].desktop);
      card.innerHTML = `<img src="${src}" alt="${val}" style="display:block;width:100%;height:auto">`;
      wrap.appendChild(card);
    });
  }

  // Delegated click
  mount.addEventListener('click', (e) => {
    const card = e.target.closest('.bundle-card');
    if (!card) return;
    const val = card.dataset.value;

    // Immediate highlight
    mount.querySelectorAll('.bundle-card').forEach(c => c.classList.remove('is-selected'));
    card.classList.add('is-selected');

    // Drive theme + variant
    window.__setBundle && window.__setBundle(val);
    clickNativeBundle(val);
    window.__syncVariant && window.__syncVariant();
  });

  function syncHighlight() {
  const forms = Array.from(document.querySelectorAll('product-form form, form[action*="/cart/add"]'));

  // Permissive read of the checked bundle radio
  let current = null;
  for (const f of forms) {
    // 1) by radio name
    const radios = Array.from(f.querySelectorAll('input[type="radio"]'))
      .filter(r => /bundle|bags/i.test(String(r.name)));
    const checked = radios.find(r => r.checked);
    if (checked) { current = checked.value; break; }

    // 2) fallback: inside a group whose legend/label mentions bundle/bags
    const group = Array.from(f.querySelectorAll('.product-form__input, .product-form__input--pill, fieldset'))
      .find(g => /bundle|bags/i.test((g.querySelector('legend, label')?.textContent || '')));
    if (group) {
      const r = group.querySelector('input[type="radio"]:checked');
      if (r) { current = r.value; break; }
    }
  }

  // If nothing detected, keep current highlight
  if (!current) return;

  const norm = s => String(s ?? '').replace(/\s+/g, ' ').trim().toLowerCase();
  document.getElementById('bundle-image-options')
    ?.querySelectorAll('.bundle-card')
    .forEach(c => {
      c.classList.toggle('is-selected', norm(c.dataset.value) === norm(current));
    });
}

  document.addEventListener('variant:change', syncHighlight);
  document.addEventListener('shopify:section:load', syncHighlight);

  // Hardened periodic sync
  if (!window.__bundleSyncLoop) {
    window.__bundleSyncLoop = setInterval(syncHighlight, 300);
  }

  buildOnce();
  syncHighlight();
})();
